export const SET_PAGE_LOADED = "SET_PAGE_LOADED";
export const SET_PAGE_LOADING = "SET_PAGE_LOADING";
